import { Dialog } from 'primereact/dialog';
import { useTaskDetailsPopup } from '../../Hooks/Features/ProjectGlance/useTaskDetailsPopup';
import { SkeletonDataTable } from '../Loader/Loader';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import { Tooltip } from 'primereact/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from 'primereact/menu';

const TaskDetailsPopup = ({ projectId, detailsPopup, onClose, header, payloadData }) => {

  const { loader, columns, rowData, tooltip, handleExcelDownload, overlayRef, saveColumnConfiguration, getMenuItems, isChange, displayColumns, setDisplayColumns } = useTaskDetailsPopup({ projectId, detailsPopup, payloadData, header });

  return (
    <div>
      <Dialog visible={detailsPopup?.visible} onHide={() => onClose()} className='modal-xlarge' header={header} draggable={false} blockScroll>
        <div className='d-flex justify-content-end gap-2 mb-2'>
          <button className='sk-btn-primary' title={displayColumns?.viewAll ? 'Custom Columns' : 'Default Columns'} onClick={() => setDisplayColumns((prev) => ({ ...prev, viewAll: !displayColumns?.viewAll, apiCall: true }))}><FontAwesomeIcon icon={`fa-solid fa-${displayColumns?.viewAll ? "table-cells-row-lock" : "table-list"}`} /></button>
          <button className='sk-btn-primary' title='Columns Configuration' onClick={(e) => overlayRef.current?.toggle(e)}><FontAwesomeIcon icon="fa-solid fa-sliders" /></button>
          <button className='sk-btn-primary' title='Download Excel' onClick={() => handleExcelDownload()}><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>
        </div>
        <div style={{ maxHeight: "70vh", overflow: "auto" }}>
          {loader ? <SkeletonDataTable numSkeletons={(rowData?.[0]?.children?.length > 0 && rowData?.[0]?.children?.length < 25) ? rowData?.[0]?.children?.length + 2 : 25} />
            : <CommonGrid columns={columns} data={rowData} strippedTable={true} headerHeight={60} />
          }

          <Menu ref={overlayRef} model={getMenuItems()} popup className="survey-menu bucket-config" onHide={() => { if (isChange?.current) { saveColumnConfiguration(); } }} />

          <Tooltip target=".project-glance-stage" position="top" escape="false" className='project-glance-tooltip'>
            {tooltip?.key === "stage" ?
              <div style={{ width: "9vw" }}>
                <div className='fw-bold pb-1 fs-6'>Stage Duration</div>
                <div className='d-flex justify-content-between' >
                  <div>Backlog</div>
                  <div>{tooltip?.data?.backlog}h</div>
                </div>
                <div className='d-flex justify-content-between' >
                  <div>In Progress</div>
                  <div>{tooltip?.data?.in_progress}h</div>
                </div>
                <div className='d-flex justify-content-between border-bottom' >
                  <div>Done</div>
                  <div>{tooltip?.data?.done}h</div>
                </div>
                <div className='d-flex justify-content-between fw-bold' >
                  <div>Total</div>
                  <div>{tooltip?.data?.total}h</div>
                </div>
              </div> : tooltip?.key === "past_sprint" ?
                <div>
                  <div className='fw-bold pb-1 fs-6 border-bottom mb-1'>Past Sprints</div>
                  {tooltip?.data?.map(item =>
                    <div>
                      {item}
                    </div>)}
                </div> : <></>
            }
          </Tooltip>
        </div>
      </Dialog>
    </div>
  )
}

export default TaskDetailsPopup